import { Component, Input } from '@angular/core';
import { CashcutDetailModel } from '../../../shared/models/cashcutDetail.model';

@Component({
  selector: 'app-cashcut-details-receipt',
  templateUrl: './cashcut-details-receipt.component.html',
  styleUrls: ['./cashcut-details-receipt.component.scss'],
})
export class CashcutDetailsReceiptComponent {
  @Input() cashcut: CashcutDetailModel;

  constructor() {}

  onPrint(): void {
    window.print();
  }
}
